import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { hash, urlWebsite } from '../../config';
import { useConfiguration } from '../../hooks/Configuration';
import api from '../../services/api';
import themeDefault from '../../styles/ThemeComponents';
import { loadFromJson } from '../../utils/loadFromJson';
import { Container, Sponsor, Apoio, SponsorGrid, ApoioGrid } from './styles';


interface ISponsor {
  url: string;
  link_url?: string;
  sort?: number;

}
interface IParamsURL {
  projectHash?: string;
  eventHash?: string;
}
interface ISponsors {
  title: string;
  position: number;
  status: string;
  sponsors: Array<ISponsor>;
  size?: string;

}

interface IProps {
  limit: number;
}

const SponsorsOnDemand: React.FC<IProps> = ({ children, limit }) => {
  const { configuration } = useConfiguration();
  const [sponsors, setSponsors] = useState<Array<ISponsors>>([])
  const { projectHash, eventHash } = useParams<IParamsURL>();
  useEffect(() => {

    const load = async () => {



      let data: Array<ISponsors> = [];

      const jsonData = await loadFromJson({ hash: hash, project_id: 'ondemand', table: 'Sponsor' });

      if (jsonData) {
        data = jsonData || [];
      }
      else {
        const response = await api.get(`sponsors-list/ondemand`);
        data = response.data.rows;
      }





      data.map(sp => {

        sp.sponsors.map(s => {
          s.sort = Math.random();

        })
      });

      /*
            response.data.rows.map(sp => {
              sp.sponsors.sort((a, b) => a.sort < b.sort ? 1 : a.sort > b.sort ? -1 : 0);
      
            })
      */



      if (data) {
        setSponsors(data);
      }
      return;
    }

    load();

  }, [])

  return (
    <>


      {sponsors && sponsors.length > 0 && <Container id="patrocinadores" style={{ margin: '20px 0px', background: 'none' }}>
        { /* <h2 style={{ color: 'rgb(0,14,64)', fontSize: '32px', marginTop: '10px', marginBottom: '25px' }} >Patrocinadores</h2> */}

        {sponsors && sponsors.map(lists => (
          lists.status === 'Não' ? <> </> :

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', minWidth: '350px', maxWidth: '1000px', margin: '10px 0px' }}>
              <h2 style={{ color: '#fff', fontSize: '24px', marginTop: '10px', marginBottom: '15px', }}>{lists.title}</h2>
              <ApoioGrid size={lists.size}>

                {lists.sponsors && lists.sponsors.map((apoio, index) => index >= lists.position ? <></> : (apoio.link_url ? <a href={apoio.link_url} target="_BLANK" style={{ background: '#fff' }}><Apoio background={`${urlWebsite}/${apoio.url}`} key={apoio.url} /></a> : <div style={{ background: '#fff' }} ><Apoio background={`${urlWebsite}/${apoio.url}`} key={apoio.url} /></div>))}

              </ApoioGrid>
            </div>

        ))


        }

      </Container>}

    </>
  );
};

export default SponsorsOnDemand;
